function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "545px",
    height: "545px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M -0.5,-0.5 C 181.167,-0.5 362.833,-0.5 544.5,-0.5C 544.5,181.167 544.5,362.833 544.5,544.5C 362.833,544.5 181.167,544.5 -0.5,544.5C -0.5,362.833 -0.5,181.167 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afafaf",
    d: "M 510.5,19.5 C 351.334,18.5004 192.001,18.167 32.5,18.5C 111.43,17.8319 191.097,17.4986 271.5,17.5C 351.5,17.8333 431.5,18.1667 511.5,18.5C 511.376,19.1067 511.043,19.44 510.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 32.5,18.5 C 192.001,18.167 351.334,18.5004 510.5,19.5C 431.201,99.2988 351.701,178.965 272,258.5C 191.965,178.632 112.132,98.6321 32.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afafaf",
    d: "M 18.5,32.5 C 18.167,192.001 18.5004,351.334 19.5,510.5C 19.44,511.043 19.1067,511.376 18.5,511.5C 18.1667,431.5 17.8333,351.5 17.5,271.5C 17.4986,191.097 17.8319,111.43 18.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 18.5,32.5 C 98.6321,112.132 178.632,191.965 258.5,272C 178.965,351.701 99.2988,431.201 19.5,510.5C 18.5004,351.334 18.167,192.001 18.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 522.5,34.5 C 523.833,113.331 524.5,192.497 524.5,272C 524.5,351.334 524.167,430.501 523.5,509.5C 444.035,430.535 364.701,351.368 285.5,272C 364.674,192.992 443.674,113.826 522.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afafaf",
    d: "M 523.5,509.5 C 524.167,430.501 524.5,351.334 524.5,272C 524.5,192.497 523.833,113.331 522.5,34.5C 522.811,33.5222 523.478,32.8555 524.5,32.5C 525.667,192.166 525.833,351.832 525,511.5C 524.283,510.956 523.783,510.289 523.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 105.5,451.5 C 112.778,445.891 119.444,439.558 125.5,432.5C 137.141,419.192 149.474,406.525 162.5,394.5C 169.778,388.891 176.444,382.558 182.5,375.5C 192.78,363.552 203.78,352.219 215.5,341.5C 224.112,334.556 232.112,326.889 239.5,318.5C 249.629,307.536 259.963,296.702 270.5,286C 271.167,285.333 271.833,285.333 272.5,286C 352.167,365.667 431.833,445.333 511.5,525C 351.832,525.833 192.166,525.667 32.5,524.5C 56.6377,499.811 80.971,475.478 105.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 239.5,318.5 C 232.112,326.889 224.112,334.556 215.5,341.5C 222.888,333.111 230.888,325.444 239.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 182.5,375.5 C 176.444,382.558 169.778,388.891 162.5,394.5C 168.556,387.442 175.222,381.109 182.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 125.5,432.5 C 119.444,439.558 112.778,445.891 105.5,451.5C 111.556,444.442 118.222,438.109 125.5,432.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ecb3ef3678551504f869e9e46cb76faf.svg";
export { ForwardRef as ReactComponent };